'use client';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import PlaylistCard from '@repo/ui/src/components/PlaylistCard';
import { LinkProps, MediaType, PlaylistItem, YoutubeLinkProps } from '@repo/ui/src/types';

interface YoutubeCardProps {
  associatedPlaylist?: {
    body?: Array<PlaylistItem>;
  };
  title?: string;
  description?: string;
  asset?: MediaType;
  youtubeId?: string;
  youtubeLink?: YoutubeLinkProps;
  embedUrl?: string;
  _playlistData?: Array<PlaylistItem>;
  link?: {
    link: LinkProps;
  };
  ariaLabel?: string;
  darkMode?: boolean;
  name?: string;
  duration?: string;
}

const YoutubeCard = ({
  associatedPlaylist,
  asset,
  title,
  description,
  youtubeId,
  youtubeLink,
  embedUrl,
  _playlistData,
  link,
  ariaLabel,
  darkMode,
  name,
  duration,
}: YoutubeCardProps) => {
  const { push } = useModal(ModalID.video);
  const builtYoutubeLink: YoutubeLinkProps = youtubeLink || {
    associatedPlaylist,
    _meta: { deliveryId: '', deliveryKey: '', schema: '' },
    name: name || '',
    youtubeId,
    contentUrl: embedUrl || '',
    duration: parseInt(duration || '0'),
    embedUrl: embedUrl || '',
    thumbnailUrl: '',
    uploadedThumbnail: [],
  };

  return (
    <div role="group" aria-label={ariaLabel} className="tw-h-full">
      <div tabIndex={0}>
        <PlaylistCard
          title={title}
          description={description}
          asset={asset}
          youtubeLink={youtubeLink}
          link={link}
          darkMode={darkMode}
          onClick={() =>
            push({
              link,
              youtubeLink: builtYoutubeLink,
              playlistItems: associatedPlaylist ? associatedPlaylist.body : _playlistData,
            })
          }
        />
      </div>
    </div>
  );
};

export default YoutubeCard;
